import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const SERVICES = [
  {
    id: "01",
    span: "md:col-span-8",
    title: "Prowadzenie projektu inwestycyjnego",
    desc: "Od koncepcji poprzez projektantów, procedury administracyjne i wykonawców aż po realizację i komercjalizację. Inwestor zapewnia kapitał — ja pomagam przeprowadzić inwestycję jako zewnętrzny Investment / Development Manager.",
    flow: ["Koncepcja", "Projekt", "Procedury", "Wykonawcy", "Realizacja", "Komercjalizacja"],
  },
  {
    id: "02",
    span: "md:col-span-4",
    title: "Pośrednictwo w obrocie nieruchomościami",
    desc: "Pomagam w zakupie i sprzedaży nieruchomości – od gruntów inwestycyjnych, przez nieruchomości mieszkaniowe, po obiekty komercyjne. Nie ograniczam się do ofert dostępnych w Internecie. Docieram bezpośrednio do właścicieli nieruchomości, pomagając znaleźć odpowiednią nieruchomość, przeprowadzić proces zakupu lub skutecznie przygotować i przeprowadzić jej sprzedaż.",
  },
  {
    id: "03",
    span: "md:col-span-4",
    title: "Analiza potencjału nieruchomości",
    desc: "Co rzeczywiście można tutaj wybudować i czy inwestycja ma ekonomiczny sens? MPZP, warunki zabudowy, plan ogólny, OUZ, ZPI, możliwości zabudowy, PUM, dostęp komunikacyjny, media, ograniczenia inwestycyjne, wstępny model finansowy.",
  },
  {
    id: "04",
    span: "md:col-span-4",
    title: "Przygotowanie nieruchomości do inwestycji",
    desc: "Grunt → analiza → koncepcja → WZ / ZPI / MPZP → projekt → PnB → inwestor lub realizacja. Celem jest projekt znacznie bardziej czytelny i atrakcyjny dla inwestora niż sam niezabudowany grunt.",
  },
  {
    id: "05",
    span: "md:col-span-4",
    title: "Ekspansja sieci handlowych i usługowych",
    desc: "Wyszukuję lokale i grunty odpowiadające kryteriom konkretnej sieci. Analizuję lokalizację, otoczenie, komunikację, potencjał handlowy oraz uwarunkowania planistyczne. Pomagam w kontakcie z właścicielem, negocjacjach i doprowadzeniu procesu do podpisania umowy.",
    tag: "Stała obsługa ekspansji regionalnej — Polska południowo-wschodnia",
  },
];

export const Services = () => (
  <section id="uslugi" data-testid="services-section" className="bg-white py-24 lg:py-36">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <Reveal className="mb-16 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-[#8C6D46]">
            Usługi
          </p>
          <h2 className="font-serif text-2xl font-semibold leading-tight tracking-tight text-slate-950 sm:text-3xl lg:text-4xl">
            W czym mogę pomóc?
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-slate-500">
          Pięć obszarów, w których łączę rynek nieruchomości z realnym procesem inwestycyjnym.
        </p>
      </Reveal>

      <div data-testid="services-bento-grid" className="grid grid-cols-1 gap-6 md:grid-cols-12 lg:gap-8">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={0.06 * i} className={s.span}>
            <article
              data-testid={`service-card-${s.id}`}
              className="group flex h-full flex-col justify-between rounded-sm border border-slate-200 bg-[#FAFAFA] p-8 transition-all duration-300 hover:-translate-y-1 hover:border-[#8C6D46]/50 hover:shadow-[0_20px_50px_-20px_rgba(140,109,70,0.25)] lg:p-10"
            >
              <div>
                <div className="mb-8 flex items-center justify-between">
                  <span className="font-mono text-xs tracking-[0.2em] text-slate-400">{s.id}</span>
                  <ArrowUpRight
                    size={18}
                    className="text-slate-300 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#8C6D46]"
                  />
                </div>
                <h3 className="font-serif text-xl font-medium text-slate-900 sm:text-2xl">{s.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-slate-600">{s.desc}</p>
              </div>
              {s.flow && (
                <div data-testid="service-card-flow" className="mt-10 flex flex-wrap items-center gap-y-3">
                  {s.flow.map((step, i) => (
                    <span key={step} className="flex items-center">
                      <span className="rounded-full border border-slate-200 bg-white px-4 py-1.5 text-xs font-medium text-slate-600 transition-colors duration-300 group-hover:border-[#8C6D46]/40">
                        {step}
                      </span>
                      {i < s.flow.length - 1 && (
                        <span className="mx-2 font-mono text-xs text-[#8C6D46]">→</span>
                      )}
                    </span>
                  ))}
                </div>
              )}
              {s.tag && (
                <p className="mt-8 border-t border-slate-200 pt-5 font-mono text-[11px] uppercase tracking-[0.15em] text-[#8C6D46]">
                  {s.tag}
                </p>
              )}
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
